import { b as useFormContext$1 } from '../../../3rdPartyModules/react-hook-form/dist/index.esm-CTOtYSSt.js';
import { u as useFormId } from './useFormId-Cc85-a5p.js';
import { u as useSubmitErrorMessage } from './useSubmitErrorMessage-BKr3iztZ.js';
import { u as useFormElementContext } from './useFormElementContext-BW0cBk3k.js';

const useFormContext = () => {
  const {
    formState,
    getValues,
    reset,
    control,
    trigger
  } = useFormContext$1();
  const id = useFormId();
  const submitErrorMessage = useSubmitErrorMessage();
  const {
    label,
    handleSubmit
  } = useFormElementContext();
  return {
    formState,
    getValues,
    reset,
    control,
    trigger,
    submitErrorMessage,
    id,
    label,
    handleSubmit
  };
};

export { useFormContext as u };
//# sourceMappingURL=useFormContext-DAFplQw7.js.map
